import React, { useEffect, useState } from "react";
import "../Style/Component/Detailstables.css";
import file from "../Assets/Detailstable/file.svg";
import Ridedetailcard from "./Ridedetailcard";
import { useSelector } from "react-redux";
import { getWithTokenAPI } from "../Util/Api";
import { useParams } from "react-router-dom";
import { FaMotorcycle } from "react-icons/fa";
import { MdPayment } from "react-icons/md";
import Select from "react-select";
const Detailtables = ({ data, stats }) => {
  const [activeTab, setActiveTab] = useState("details");
  const [tpage, setTpage] = useState(4);
  const [page, setPage] = useState(1);
  const { type, id } = useParams();
  const formatINR = (amount) => {
    if (!amount || amount === 0) return "0";
    return `₹ ${amount.toLocaleString("en-IN")}`;
  };
  const [ridecards, setRideCards] = useState([]);
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const [rideFilter, setRideFilter] = useState("");

  const [paymentData, setPaymentData] = useState([]);

  useEffect(() => {
    if (stats?.paymentDetails) {
      const formattedData = stats.paymentDetails.map((item) => ({
        driverName: item?.driverName || "",
        customerName: item?.customerName || "",
        date: item?.date,
        from: item?.from,
        to: item?.to,
        amount: item?.amount,
        paymentMethod: item?.paymentMethod,
      }));

      setPaymentData(formattedData);
    }
  }, [stats]);

  console.log(paymentData, "paymentDatapaymentData");
  const rideFilterOptions = [
    { value: "", label: "All" },
    { value: "today", label: "Today" },
    { value: "week", label: "This Week" },
    { value: "month", label: "Last 30 Days" },
  ];

  // useEffect(() => {
  //   const fetchrides = async () => {
  //     const api =
  //       data?.roletype === "user"
  //         ? `/rider-booking?userId=${id}`
  //         : `/rider-booking?driverId=${id}`;
  //     try {
  //       const res = await getWithTokenAPI(token, api);
  //       console.log(res, "RES");
  //       setRideCards(res?.data?.bookings);
  //     } catch {
  //       console.log("Error in fetching Limit Api");
  //     }
  //   };
  //   fetchrides();
  // }, [data]);

  useEffect(() => {
    if (activeTab !== "ride") return;

    const fetchrides = async () => {
      const api =
        data?.roletype === "user"
          ? `/rider-booking?userId=${id}&filter=${rideFilter}`
          : `/rider-booking?driverId=${id}&filter=${rideFilter}`;

      try {
        const res = await getWithTokenAPI(token, api);
        console.log(res, "RES");
        setRideCards(res?.data?.bookings);
      } catch {
        console.log("Error in fetching rides");
      }
    };

    fetchrides();
  }, [data, rideFilter, activeTab]);

  function formatDate(isoDate) {
    if (!isoDate) return "";

    const date = new Date(isoDate);

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${day}-${month}-${year}`;
  }

  return (
    <div className="detailstables">
      <div className="tabss">
        {(type === "driver"
          ? ["details", "sos", "ride", "bank", "dd"]
          : ["details", "sos", "ride", "bank"]
        ).map((tab) => (
          <span
            key={tab}
            className={activeTab === tab ? "active" : ""}
            onClick={() => setActiveTab(tab)}
          >
            {tab === "details"
              ? "Personal Details"
              : tab === "sos"
                ? "SOS Details"
                : tab === "ride"
                  ? "Ride Details"
                  : tab === "bank"
                    ? "Payment Details"
                    : "Driver Documents"}
          </span>
        ))}

        {/* {activeTab === "ride" && (
          <div style={{ marginBottom: "15px", width: "220px" }}>
            <Select
              options={rideFilterOptions}
              placeholder="Filter Rides"
              value={rideFilterOptions.find((opt) => opt.value === rideFilter)}
              onChange={(selected) => setRideFilter(selected?.value)}
              isClearable
            />
          </div>
        )} */}
        {activeTab === "ride" && (
          <div style={{ width: "170px" }}>
            <Select
              options={rideFilterOptions}
              placeholder="Filter Rides"
              value={rideFilterOptions.find((opt) => opt.value === rideFilter)}
              onChange={(selected) => setRideFilter(selected?.value)}
              isClearable
              styles={{
                control: (base, state) => ({
                  ...base,
                  backgroundColor: "#f8f9fc", // Light grayish-blue background from your image
                  borderColor: "#e2e8f0", // Very soft border color
                  borderRadius: "10px",
                  marginBottom: "5px",
                  boxShadow: "none",
                  "&:hover": {
                    borderColor: "#cbd5e1",
                  },
                }),
                valueContainer: (base) => ({
                  ...base,
                  padding: "0 7px",
                }),
                singleValue: (base) => ({
                  ...base,
                  color: "#1e293b", // Dark text for "All"
                  fontSize: "15px",
                  fontWeight: "500",
                }),
                placeholder: (base) => ({
                  ...base,
                  color: "#94a3b8",
                }),
                indicatorSeparator: () => ({
                  display: "none", // Removes the line between 'x' and arrow
                }),
                dropdownIndicator: (base) => ({
                  ...base,
                  color: "#cbd5e1", // Light gray arrow
                  paddingRight: "10px",
                }),
                clearIndicator: (base) => ({
                  ...base,
                  color: "#cbd5e1", // Light gray 'x'
                }),
                menu: (base) => ({
                  ...base,
                  borderRadius: "10px",
                  marginTop: "8px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                  border: "1px solid #e2e8f0",
                }),
                option: (base, { isFocused, isSelected }) => ({
                  ...base,
                  backgroundColor: isSelected
                    ? "#e2e8f0"
                    : isFocused
                      ? "#f1f5f9"
                      : "white",
                  color: "#1e293b",
                  cursor: "pointer",
                }),
              }}
            />
          </div>
        )}
      </div>
      <div className="detailstablesmain">
        {activeTab === "details" && (
          <div className="personaldetailstable">
            <div className="personaldetailstablerow odd">
              <span className="personaldetailsrowlabel">Name</span>
              <span>{data?.name}</span>
            </div>
            <div className="personaldetailstablerow">
              <span className="personaldetailsrowlabel">Email</span>
              <span>{data?.email}</span>
            </div>
            <div className="personaldetailstablerow odd">
              <span className="personaldetailsrowlabel">Phone no</span>
              <span>+91{data?.phoneNumber}</span>
            </div>
            <div className="personaldetailstablerow">
              <span className="personaldetailsrowlabel">Gender</span>
              <span>{data?.gender}</span>
            </div>
            <div className="personaldetailstablerow odd">
              <span className="personaldetailsrowlabel">DOB</span>
              <span>{data?.dateOfBirth}</span>
            </div>
            <div className="personaldetailstablerow">
              <span className="personaldetailsrowlabel">Address </span>
              <span>{data?.location1?.[0]?.currentAddress}</span>
            </div>
          </div>
        )}
        {activeTab === "sos" && (
          <div className="personaldetailstable">
            <div className="personaldetailstablerow odd">
              <span className="personaldetailsrowlabel">Name</span>
              <span>{data?.emergencyContact?.name}</span>
            </div>
            <div className="personaldetailstablerow">
              <span className="personaldetailsrowlabel">Phone no</span>
              <span>+91{data?.emergencyContact?.contactNo}</span>
            </div>
            <div className="personaldetailstablerow odd">
              <span className="personaldetailsrowlabel">SOS Call Count</span>
              <span>{data?.totalSOSCount}</span>
            </div>
          </div>
        )}
        {activeTab === "bank" && (
          <div className="paymenttablesdiv">
            <table className="paymenttables">
              <thead>
                <tr>
                  <th> {type === "driver" ? "User Name" : "Driver Name"}</th>
                  <th>Date</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Amount</th>
                  <th>Payment Method</th>
                </tr>
              </thead>

              <tbody>
                {paymentData && paymentData.length > 0 ? (
                  paymentData.map((row, index) => (
                    <tr key={index}>
                      <td className="paymenttables-driver">
                        {type === "driver" ? row.customerName : row.driverName}
                      </td>
                      <td>{formatDate(row.date)}</td>
                      <td>{row.from}</td>
                      <td>{row.to}</td>
                      <td className="paymenttables-amount">
                        {formatINR(row.amount)}
                      </td>
                      <td className="paymenttables-method">
                        {row.paymentMethod}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="6"
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      <p
                        style={{
                          width: "70vw",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          fontSize: "16px",
                        }}
                      >
                        <MdPayment
                          style={{ fontSize: "80px", color: "var(--primary)" }}
                        />{" "}
                        No Payment Details
                      </p>
                    </td>
                  </tr>
                )}
              </tbody>
              {/* <tfoot>
                <tr>
                  <td colSpan="14">
                    {tpage > 1 && (
                      <div className="pagination">
                        {page > 1 && (
                          <button
                            className="page-btn"
                            onClick={() => setPage((page) => page - 1)}
                          >
                            ‹
                          </button>
                        )}
                        {page > 1 && (
                          <button
                            className="page-btn"
                            onClick={() => setPage(1)}
                          >
                            1
                          </button>
                        )}
                        {page === tpage && <span className="page-dots">…</span>}
                        <button className="page-btn pgnoactive">{page}</button>

                        {page !== tpage && <span className="page-dots">…</span>}

                        {page !== tpage && (
                          <button
                            className="page-btn"
                            onClick={() => setPage(tpage)}
                          >
                            {tpage}
                          </button>
                        )}

                        {page < tpage && (
                          <button
                            className="page-btn"
                            onClick={() => setPage((page) => page + 1)}
                          >
                            ›
                          </button>
                        )}
                      </div>
                    )}
                  </td>
                </tr>
              </tfoot> */}
            </table>
          </div>
        )}
        {activeTab === "dd" && (
          <div className="driverdocument-card">
            <div className="driverdocument-header">Documents</div>
            <div className="driverdocument-list">
              {data?.aadhaarimg && (
                <div className="driverdocument-row">
                  <span className="driverdocument-name">Aadhar Card</span>

                  <a
                    href={data?.aadhaarimg}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="driverdocument-viewbtn"
                  >
                    <img
                      className="driverdocument-icon"
                      src={file}
                      alt="file"
                    />
                    View
                  </a>
                </div>
              )}
              {/* {data && (
                <div className="driverdocument-row">
                  <span className="driverdocument-name">Passport</span>

                  <button className="driverdocument-viewbtn">
                    <a href={data?.} target="_blank" rel="noopener noreferrer">
                      <img className="driverdocument-icon" src={file}></img>
                    </a>
                    View
                  </button>
                </div>
              )}
              {data && (
                <div className="driverdocument-row">
                  <span className="driverdocument-name">Voter ID</span>

                  <button className="driverdocument-viewbtn">
                    <a href={data} target="_blank" rel="noopener noreferrer">
                      <img className="driverdocument-icon" src={file}></img>
                    </a>
                    View
                  </button>
                </div>
              )} */}
              {data?.driverDetails?.license?.licenseImage && (
                <div className="driverdocument-row">
                  <span className="driverdocument-name">License</span>

                  <a
                    href={data?.driverDetails?.license?.licenseImage}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="driverdocument-viewbtn"
                  >
                    <img className="driverdocument-icon" src={file}></img>
                    View
                  </a>
                </div>
              )}
              {data?.driverDetails?.vehicle?.insurance?.insuranceDocument && (
                <div className="driverdocument-row">
                  <span className="driverdocument-name">
                    Insurance Certificate
                  </span>

                  <button className="driverdocument-viewbtn">
                    <a
                      href={
                        data?.driverDetails?.vehicle?.insurance
                          ?.insuranceDocument
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img className="driverdocument-icon" src={file}></img>
                    </a>
                    View
                  </button>
                </div>
              )}
              {data?.driverDetails?.digitalSignature && (
                <div className="driverdocument-row">
                  <span className="driverdocument-name">Digital Signature</span>

                  {/* <button className="driverdocument-viewbtn"> */}
                  <a
                    href={data?.driverDetails?.digitalSignature}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="driverdocument-viewbtn"
                  >
                    <img className="driverdocument-icon" src={file}></img> View
                  </a>

                  {/* </button> */}
                </div>
              )}
              {data?.driverDetails?.vehicle?.vehiclePhotos && (
                <div className="driverdocument-row">
                  <span className="driverdocument-name">Vehicle Photos</span>

                  {/* <button className="driverdocument-viewbtn"> */}
                  <a
                    href={data?.driverDetails?.vehicle?.vehiclePhotos?.[0]}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="driverdocument-viewbtn"
                  >
                    <img className="driverdocument-icon" src={file}></img>
                    View
                  </a>
                  {/* </button> */}
                </div>
              )}
            </div>
          </div>
        )}
        {activeTab === "ride" && (
          <div className="ridelist">
            {Array.isArray(ridecards) && ridecards.length > 0 ? (
              ridecards.map((item, index) => (
                <Ridedetailcard key={index} ride={item} />
              ))
            ) : (
              <p
                style={{
                  width: "70vw",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  fontSize: "16px",
                }}
              >
                <FaMotorcycle
                  style={{ fontSize: "80px", color: "var(--primary)" }}
                />
                No rides found
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Detailtables;
